import React from 'react';
import { formatDate, long_date_format } from '@plone/volto/helpers/Utils/Date';
import { useSelector } from 'react-redux';

const FormattedDate = ({
  date,
  format,
  long,
  includeTime,
  relative,
  className,
  locale,
  children,
}) => {
  const language = useSelector((state) => locale || state.intl.locale);
  const toDate = (d) => (typeof d === 'string' ? new Date(d) : d);
  const args = {
    date,
    long,
    includeTime,
    format: { day: 'numeric', month: 'long', year: 'numeric' },
    locale: 'en-GB',
  };
  const new_date = new Date(toDate(date));
  if (Object.prototype.toString.call(new_date) === '[object Date]') {
    if (isNaN(new_date)) {
      return <span>bad date</span>;
    }
  } else {
    return <span>not a date</span>;
  }

  return (
    <time
      className={className}
      dateTime={date}
      title={new Intl.DateTimeFormat(language, long_date_format)
        .format(new_date)
        .replace('\u202F', ' ')}
    >
      {children
        ? children(
            formatDate({
              ...args,
              formatToParts: true,
            }),
          )
        : formatDate(args)}
    </time>
  );
};

export default FormattedDate;
